<template>
  <section class="drawer-layout__right" v-show="visible">
    <div class="drawer-layout__right-scroll">
      <FinalOrderListPartial
        :title="title"
        :summary="summary"
        :bookings="bookings"
        :subtotal="subtotal"
        :status="status"
        :is-refunded="isRefunded"
        :calculateOrder="extraGuestAdjustments"
        :mode="'view'"
      />
      <CalculatedOrderListPartial :price-adjustments="adjustments" :subtotal="subtotal" :stay-nights="stayNights" :mode="'view'" />
      <PaymentInfoPartial :info="paymentInfo" class="section-gap" />
      <InvoiceInfoPartial :info="invoiceInfo" class="section-gap" />
    </div>
  </section>
</template>

<script>
import FinalOrderListPartial from './FinalOrderListPartial.vue'
import CalculatedOrderListPartial from './CalculatedOrderListPartial.vue'
import PaymentInfoPartial from './PaymentInfoPartial.vue'
import InvoiceInfoPartial from './InvoiceInfoPartial.vue'

export default {
  name: 'ViewOrderRightPanelPartial',
  components: {
    FinalOrderListPartial,
    CalculatedOrderListPartial,
    PaymentInfoPartial,
    InvoiceInfoPartial,
  },
  props: {
    visible: { type: Boolean, default: true },
    title: { type: String, default: '' },
    summary: { type: Object, default: () => ({}) },
    bookings: { type: Array, default: () => [] },
    subtotal: { type: Number, default: 0 },
    status: { type: String, default: '' },
    extraGuestAdjustments: { type: Object, default: () => ({}) },
    adjustments: { type: Array, default: () => [] },
    stayNights: { type: Number, default: 1 },
    paymentInfo: { type: Object, default: () => ({}) },
    invoiceInfo: { type: Object, default: () => ({}) },
    isRefunded: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/hotel-view-order.scss';
</style>
